import React from 'react';
import { useT } from '@repo/common';
import HeaderText from '../../Common/HeaderText';
import MyWorkshopsHeaderButton from './MyWorkshopsHeaderButton';

const MyWorkshopsHeader = ({
  currentFilter,
  onFilterChange,
  workshopsList,
  hasAnyWorkshop,
}) => {
  const t = useT();
  return (
    <div className='flex flex-col w-full items-start justify-between'>
      <HeaderText label={t('My Workshops', '나의 워크숍')} />
      <MyWorkshopsHeaderButton
        currentFilter={currentFilter}
        onFilterChange={onFilterChange}
        workshopsList={workshopsList}
        hasAnyWorkshop={hasAnyWorkshop}
      />
    </div>
  );
};

export default MyWorkshopsHeader;
